<div class="col-md-12 mb-30">
  <div class="card card-statistics h-100">
    <div class="card-body">
      <h5 class="card-title border-0 pb-0">Calibration Certificate Details '{{inner_Certificate.title}}'</h5>
      <br />
      <br />

      <div class="row">
        <div class="form-group col-md-6">

          <button *ngIf="!Procssing" (click)="Submit()" type="button" class="btn btn-success" style="margin-right: 5px;"><i
              class="fa  fa-plus-circle"></i> Register Information </button>
          <img *ngIf="Procssing" src="assets/Loading.gif" style="width: 25px;" />
        </div>
      </div>

      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>Title</th>
              <th>Additional Decimal Places Beyond Measurement Uncertainty </th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of CertificatenoFloatPoint_DataList">
              <td>{{CertificatenoFloatPoint_DataList.indexOf(item)+1}}</td>
              <td>{{item.title}}</td>
              <td>
                <input type="number" style="width: 70px;" name="code_{{CertificatenoFloatPoint_DataList.indexOf(item)}}"
                  [(ngModel)]="item.code">
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
